import React, {Component} from 'react';

import ReactImageMagnify from 'react-image-magnify';
import LostItemFunctions from '../LostItem/LostItemFunctions';
class LostItemDetailViewer extends Component {
    constructor(props) {
      super(props);

        this.state = {
            lostItem :  props.lostItem
        }
    }


    render() {
        return (

            <div>
           
            <div className='row'>
                 <h5> Detail Viewer </h5>
            </div>
            <div className='row'>
                <div className='col-6'>
                <ReactImageMagnify enlargedImagePosition='over' {...{
                    smallImage: {
                        alt: this.state.lostItem.shortDescription,
                        isFluidWidth: true,
                        src: this.state.lostItem.url,
                        width: 500,
                        height: 500,
                    },
                    largeImage: {
                        src: this.state.lostItem.url,
                        width: 1200,
                        height: 1800
                    }
                }} />

                <p className='text-muted'>Mouse over to magnify </p>
            </div>

            <div className='col-6' style={{width:550}}>
                <div className='row'><h3>{this.state.lostItem.shortDescription}</h3> </div>
                <div className='row'><p className='text-primary'>{this.state.lostItem.longDescription}</p> </div>
                <div className='row'><p className='text-primary'><b>Found On:</b> {LostItemFunctions.formatDate(this.state.lostItem.foundDate)} at {LostItemFunctions.formatTime(this.state.lostItem.foundDate)}</p> </div>
                <hr/>
                <div className='row'><h6>Location Information: </h6></div>

             

                    <div className='row '><div className='col-4 text-primary border-primary text-right'><b>Airport: </b></div><div className ='col'>{this.state.lostItem.airportCd}</div></div>
                 
                    <div className='row '><div className='col-4 text-primary   text-right'><b>Terminal:</b></div><div className ='col'>{this.state.lostItem.terminal}</div></div>
   
            
                    <div className='row '><div className='col-4 text-primary  text-right'><b>Gate: </b></div><div className ='col'> {this.state.lostItem.gate} </div></div>
                    <div className='row '><div className='col-4 text-primary  text-right'><b>Flight#: </b></div><div className ='col'>{this.state.lostItem.flightNumber} </div></div>
                    <div className='row '><div className='col-4 text-primary  text-right'><b>Seat: </b></div><div className ='col'>{this.state.lostItem.seat} </div></div>

              


                <hr/>
                <div className='row'><h5>Lost &amp; Found Contact </h5></div>
                <div className='row'><h6 className="text-info">{this.state.lostItem.subscriptionVenueAlias}</h6></div>
                <div className='row'><p className='text-primary'>Phone: {this.state.lostItem.claimPhone}</p></div>
                <div className='row'><p className='text-primary'>Email: <a href= {'mailto:' + this.state.lostItem.claimEmail + '?subject=**BOUNTE Claim Notification for : ' + this.state.lostItem.shortDescription + ' claimed'}>{this.state.lostItem.claimEmail}</a></p></div>
                <div className='row'><p className='text-primary'>SMS: {this.state.lostItem.claimSMSNumbers}</p></div>


                </div>
            </div>
            </div>
        )
    }

}

export default LostItemDetailViewer;